<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページはURLの正規化が最適に設定されています。
        </p>
        <p v-else>
          あなたのWebページは「www」がある場合、ない場合の両方でアクセスできるため検索エンジンが正しく評価できておりません。
        </p>
      </div>
    </li>
    <li
      v-if="detail.url.normal && detail.url.www"
      class="c-list--checkup__item"
    >
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <p>
          {{ detail.url.normal }}<br />{{ detail.url.www
          }}<br />URLでどちらもアクセスできます。
        </p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          このテストに合格するには、両方のアドレス（{{ detail.url.normal }}と{{
            detail.url.www
          }}）が同じURLに解決されるように、.htaccessファイルで301書き換えルールの使用を検討する必要があります。
        </p>
        <ul class="c-list--disc">
          <li>
            <p>
              http://www.example.comをhttp://example.comにリダイレクトする場合、これを使用できます。
            </p>
            <pre
              class="c-text--pre"
            ><code>RewriteCond %{HTTP_HOST} ^www.example.com$
RewriteRule (.*)$ http://example.com/$1 [R=301,L]</code></pre>
          </li>
          <li>
            <p>
              http://example.comをhttp://www.example.comにリダイレクトする場合、これを使用できます。
            </p>
            <pre
              class="c-text--pre"
            ><code>RewriteCond %{HTTP_HOST} !^www.example.com$
RewriteRule (.*)$ http://www.example.com/$1 [L,R=301]</code></pre>
          </li>
        </ul>
        <p>
          上記の行はRewriteEngine
          On行の後に配置する必要があることに注意してください。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
